import { tr } from 'i18n';
import { useTranslation as useInterfaceLanguage } from 'react-i18next';
import ChevronLeftIcon from '@mui/icons-material/ChevronLeft'
import MenuIcon from '@mui/icons-material/Menu'
import Divider from '@mui/material/Divider'
import MuiDrawer from '@mui/material/Drawer'
import IconButton from '@mui/material/IconButton'
import List from '@mui/material/List'
import ListItemButton from '@mui/material/ListItemButton'
import { styled } from '@mui/material/styles'
import * as React from 'react'
import { useState, useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'


import surveyicon from 'assets/side_panel_icons/6order.png'
import userInfo from 'utils/userInfo'
import registration from 'assets/side_pane_new_icons/createuser.svg'

import task from 'assets/side_pane_new_icons/note.svg'
import teams from 'assets/side_pane_new_icons/team.svg'
import home from "assets/side_pane_new_icons/home.svg";

import table from "assets/side_panel_icons/tabel.png"
import leftwindow from "assets/side_panel_icons/windowsleft.png"
import rightwindow from "assets/side_panel_icons/windowsright.png"
import stylesB from './MenuW.module.scss'
import stylesW from './MenuW.module.scss'

import {
  postUserInfo,
} from "service/AuthService";
import {
  changeNavigatePosition
} from "store/slices/UserSlice";

const backgroundColor = 'var(--erp-surface)'
const textColor = 'var(--erp-text)'
const invertLevel = 'var(--theme-icon-filter, invert(0.8))'

const drawerWidth = 270

const openedMixin = (theme) => ({
  width: drawerWidth,
  borderRight: 'unset',
  transition: theme.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.enteringScreen,
  }),
  overflowX: 'hidden',
  '& img': {
    width: '19px',
    // height: '26px',
    marginBottom: '3px',
    filter: invertLevel,
  },

  '& p': {
    paddingLeft: '10px',
  },
})

const closedMixin = (theme) => ({
  transition: theme?.transitions.create('width', {
    easing: theme.transitions.easing.sharp,
    duration: theme.transitions.duration.leavingScreen,
  }),
  overflowX: 'hidden',
  borderRight: 'unset',
  width: `calc(${theme.spacing(7)} + 1px)`,
  [theme.breakpoints.up('sm')]: {
    width: `calc(${theme.spacing(7)} + 1px)`,
  },
  textAligh: 'center',
  '& img': {
    // Задаем стили для всех img элементов внутри контейнера, к которому применяется этот mixin
    width: '19px', // Замените на нужные стили
    // height: '26px', // Замените на нужные стилие
    // Замените на нужные стили
    marginBottom: '3px',
    filter: invertLevel,
  },
  '& p': {
    paddingLeft: '10px',
    marginBottom: '5px',
  },
})

const StyledDrawerHeader = styled('div')(({ theme }) => ({
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'flex-end',

  padding: theme.spacing(0, 1),
  ...theme.mixins.toolbar,
}))


// Местоположение
// Объявление глобальных переменных
let positionx = "0";
let positiony = "auto";


function move_info() {
  const user_info = userInfo();

  if (user_info?.menu_navigate_position === true) {
    const element = document.getElementById('laylayoutout');
    positionx = 'auto';
    positiony = '0';
    element.style.paddingRight = '54px';
    element.style.paddingLeft = '8px';
  }
  else {
    const element = document.getElementById('laylayoutout');
    positionx = '0';
    positiony = 'auto';
    element.style.paddingRight = '8px';
    element.style.paddingLeft = '57px';

  }
}

function move(direction, setOpen) {
  const user_info = userInfo();
  const element = document.getElementById('laylayoutout');

  if (direction === 'left') {
    positionx = '0';
    positiony = 'auto';
    element.style.paddingRight = '8px';
    element.style.paddingLeft = '57px';



  } else if (direction === 'right') {
    positionx = 'auto';
    positiony = '0';
    element.style.paddingRight = '54px';
    element.style.paddingLeft = '8px';

  }
  let data;

  const postData = async () => {

    try {
      let response = await postUserInfo(user_info.userId, data);
      const user_change = JSON.parse(localStorage.getItem('user'));
      user_change.menu_navigate_position = response.data.info;
      user_change.userInfo.menu_navigate_position = response.data.info;
      localStorage.setItem('user', JSON.stringify(user_change));
    } catch (error) {
      console.log("onoxo")
    }

  };
  postData()
  setOpen(false)
}





const Drawer = styled(MuiDrawer, {

  shouldForwardProp: (prop) => prop !== 'open',
})(({ theme, open }) => ({
  width: drawerWidth,
  flexShrink: 0,
  whiteSpace: 'nowrap',
  boxSizing: 'border-box',

  borderRight: 'unset',
  ...(open && {
    ...openedMixin(theme),
    '& .MuiDrawer-paper': {
      ...openedMixin(theme),
      left: positionx,
      right: positiony,
      background: backgroundColor,
      // Background color with 32% opacity
    },
  }),
  ...(!open && {
    ...closedMixin(theme),
    '& .MuiDrawer-paper': {
      ...closedMixin(theme),
      left: positionx,
      right: positiony,

      background: backgroundColor, // Background color with 32% opacity
    },
  }),
}))

export default function MenuDrawer() {
  useInterfaceLanguage();
  const user_info = userInfo();
  const [styles, setThem] = useState(stylesW)
  const [open, setOpen] = useState(false)
  const navigate = useNavigate()

  const user = userInfo()

  const location = useLocation()
  const handleMouseEnter = () => {
    setOpen(true)
  }

  const handleMouseLeave = () => {
    setOpen(false)
  }

  // Count visible nav items for this user
  const navItemCount =
    1 + // always 1: either "Главная" or "Перевозки"
    (user?.is_admin_of ? 2 : 0) +
    (user?.is_report_of ? 1 : 0)

  useEffect(() => {
    if (user?.them) {
      setThem(stylesW)
    }
    else {
      setThem(stylesB)
    }
    if (navItemCount <= 1) {
      // No sidebar — remove reserved padding so content fills full width
      const element = document.getElementById('laylayoutout')
      if (element) {
        element.style.paddingLeft = '0'
        element.style.paddingRight = '0'
      }
    } else {
      move_info()
    }
  }, []);

  if (navItemCount <= 1) return null

  return (
    <div>
      <Drawer
        variant="permanent"
        open={open}
        onMouseEnter={handleMouseEnter}
        onMouseLeave={handleMouseLeave}

      >
        <StyledDrawerHeader >

          {/* {open ?     <div className={styles.logo__wrapper}>
          <img src={unetLogo} alt="" />
        </div> :  null} */}
          {open ? (
            <div className={styles.logo__wrapper}>
              <p style={{ color: textColor }}>{tr("Навигация")}</p>
            </div>
          ) : null}

          <IconButton
            sx={{ color: textColor, paddingRight: '8px' }}
            aria-label={tr("Открыть меню")}
            onClick={() => setOpen((prevOpen) => !prevOpen)}
            edge="start"
          >
            {open ? <ChevronLeftIcon /> : <MenuIcon />}
          </IconButton>
        </StyledDrawerHeader>
        <Divider />
        <div className={styles.menu__list}>
          <List >

            <div className={styles.menu__section}>
              <div>

                {user?.is_personal_kyrgyzkomur ? (
                <ListItemButton
                  disablePadding
                  onClick={() => navigate(`/employee-card/`)}
                  style={
                    location.pathname.includes("employee-card")
                      ? { background: "var(--theme-surface-muted, #E8E8EF)" }
                      : {}
                  }


                >
                  <img style={
                    location.pathname.includes('employee-card')
                      ? { filter: 'invert(0.8)' }
                      : {}
                  } src={home} className={stylesW.image_icon} alt="" />

                  {open ? <p style={
                   location.pathname.includes('employee-card')
                      ? { color: "var(--theme-text, black)" }
                      : {}
                  }>{tr("Главная")}</p> : null}
                </ListItemButton>
                ) : null}

                {!user?.is_personal_kyrgyzkomur ? (
                <ListItemButton
                  disablePadding
                  onClick={() => navigate(`/report-card/`)}
                  style={
                    location.pathname.includes("report")
                      ? { background: "var(--theme-surface-muted, #E8E8EF)" }
                      : {}
                  }


                >
                  <img style={
                    location.pathname.includes('report')
                      ? { filter: 'invert(0.8)' }
                      : {}
                  } src={table} className={stylesW.image_icon} alt="" />

                  {open ? <p style={
                    location.pathname.includes('report')
                      ? { color: "var(--theme-text, black)" }
                      : {}
                  }>{tr("Перевозки")}</p> : null}
                </ListItemButton>
                ) : null}
                {user?.is_admin_of ? (
                  <>




                    <ListItemButton
                      disablePadding
                      onClick={() => navigate(`/adminpanel/`)}
                      style={
                        location.pathname.includes('adminpanel')
                          ? { background: "var(--theme-surface-muted, #E8E8EF)" }
                          : {}
                      }
                    >
                      <img style={
                        location.pathname.includes('adminpanel')
                          ? { filter: 'invert(0.8)' }
                          : {}
                      } className={styles.image_icon} src={task} alt="" />

                      {open ? <p style={
                        location.pathname.includes('adminpanel')
                          ? { color: "var(--theme-text, black)" }
                          : {}
                      }>{tr("Админ панель")}</p> : null}
                    </ListItemButton>
                  </>
                ) : null}
                {user?.is_admin_of ? (
                  <>




                    <ListItemButton
                      disablePadding
                      onClick={() => navigate(`/register_person`)}
                      style={
                        location.pathname.includes('register_person')
                          ? { background: "var(--theme-surface-muted, #E8E8EF)" }
                          : {}
                      }
                    >
                      <img style={
                        location.pathname.includes('register_person')
                          ? { filter: 'invert(0.8)' }
                          : {}
                      } className={styles.image_icon} src={registration} alt="" />

                      {open ? <p style={
                        location.pathname.includes('register_person')
                          ? { color: "var(--theme-text, black)" }
                          : {}
                      }>{tr("Создать пользователя")}</p> : null}
                    </ListItemButton>
                  </>
                ) : null}
                {user?.is_report_of ? (
                  <>
                    <ListItemButton
                      disablePadding
                      onClick={() => navigate(`/reports`)}
                      style={
                        location.pathname.includes('reports')
                          ? { background: "var(--theme-surface-muted, #E8E8EF)" }
                          : {}
                      }
                    >
                      <img style={
                        location.pathname.includes('reports')
                          ? { filter: 'invert(0.8)' }
                          : {}
                      } className={styles.image_icon} src={task} alt="" />

                      {open ? <p style={
                        location.pathname.includes('reports')
                          ? { color: "var(--theme-text, black)" }
                          : {}
                      }>{tr("Отчёты")}</p> : null}
                    </ListItemButton>
                  </>
                ) : null}
                <div style={{ padding: "8px 18px" }}>
                  <hr />
                </div>


              </div>
              <div>
                <div style={{ padding: "8px 18px" }}>
                  <hr />
                </div>
                {user_info?.menu_navigate_position ?
                  <>
                    <ListItemButton
                      disablePadding
                      onClick={() => move('left', setOpen)}

                    >
                      <img className={styles.image_icon} src={leftwindow} alt="" />
                      {open ? <p >{tr("Поместить слева")}</p> : null}
                    </ListItemButton>
                    <ListItemButton
                      disablePadding

                      style={{ filter: "invert(0.6)" }}
                    >
                      <img className={styles.image_icon} src={rightwindow} alt="" />
                      {open ? <p >{tr("Справа")}</p> : null}

                    </ListItemButton>
                  </>
                  : <>
                    <ListItemButton
                      disablePadding

                      style={{ filter: "invert(0.6)" }}
                    >
                      <img className={styles.image_icon} src={leftwindow} alt="" />
                      {open ? <p >{tr("Слева")}</p> : null}
                    </ListItemButton>
                    <ListItemButton
                      disablePadding
                      onClick={() => move('right', setOpen)}

                    >
                      <img className={styles.image_icon} src={rightwindow} alt="" />
                      {open ? <p >{tr("Поместить справа")}</p> : null}

                    </ListItemButton>
                  </>}
              </div>
            </div>
          </List>
        </div>
      </Drawer>
    </div>
  )
}
